import React, { ReactNode } from 'react'

import { Tooltip } from 'core-components/library/tooltip'

import { CategorySelectionInfo, ICategorySelectionInfoProps } from './CategorySelectionInfo'

interface IProps extends ICategorySelectionInfoProps {
  children: ReactNode
  parentCode?: string
  className?: string
}

export const CategorySelectionTooltip = ({
  children,
  parentCode,
  className,
  guidelines,
  description,
  justification,
  mode,
}: IProps) => {
  if (parentCode) {
    return <>{children}</>
  }

  return (
    <Tooltip
      tipContent={() => (
        <CategorySelectionInfo
          guidelines={guidelines}
          description={description}
          justification={justification}
          mode={mode}
        />
      )}
      className={className}
      inline
      textAlign={'left'}
    >
      {children}
    </Tooltip>
  )
}
